export default {"src":"/_next/static/media/green_frame.826ce3b2.svg","height":36,"width":98,"blurWidth":0,"blurHeight":0};